// extracted by mini-css-extract-plugin
export default {"root":"_2zo6T","message":"J_kPG","button":"Jxlh9"};